<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/adminShipmentList/">Shipments</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Shipment</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-4 " [hidden]="user.role !== 'ROLE_ADMIN'">
              <div class="form-group mb-1">
                <label class="control-label">Customer</label>
                <!-- <select id="accountOwner" class="form-control" (change)="getList()" [(ngModel)]="accountOwner" [ngModelOptions]="{standalone: true}" required>
                   <option *ngFor="let a of accountOwners" [ngValue]="a.id">{{a.ownerName}}</option>
                 </select>-->
                <ng-select id="accountOwner" [(ngModel)]="accountOwner" (change)="getList()"
                           [ngModelOptions]="{standalone: true}" required
                           [items]="accountOwners"
                           bindLabel="ownerName"
                           bindValue="id"
                           [searchFn]="customSearchAccountOwner"
                           [searchWhileComposing]="true">
                  <ng-template ng-option-tmp let-item="item">
                    {{item?.ownerName}} <br/>
                    <small>{{item?.companyName}}</small>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <div class="row">
                <div class="col-4 required">
                  <div class="form-group select-form-group ware-house ">
                    <label class="control-label">Contact</label>
                    <ng-select id="contactName" [(ngModel)]="selectedContact" (change)="getContactAddress()"
                               [ngClass]="{'service-error':statusText}" (blur)="selectContact()"
                               [ngModelOptions]="{standalone: true}" required
                               [items]="contacts"
                               bindLabel="contactName"
                               placeholder="Search for a Customer"
                               [searchFn]="customSearchFn"
                               [searchWhileComposing]="true">
                      <ng-template ng-option-tmp let-item="item">
                        {{item?.contactName}} <br/>
                        <small>{{item?.companyName}}</small>
                      </ng-template>
                      <ng-template ng-header-tmp>
                        <div>
                          <button (click)="addNewCustomer()" id="addNewContact" class="btn btn-outline-primary btn-sm">
                            <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16"
                                 fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd"
                                    d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                              <path fill-rule="evenodd"
                                    d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                            </svg>
                            Add a new contact
                          </button>
                        </div>

                      </ng-template>
                    </ng-select>
                    <div class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText">{{statusText}}</div>
                    <div id="statusText14" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText14">{{statusText14}}</div>
                    <div id="errorMessage" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!errorMessage">{{errorMessage}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group  select-form-group">
                    <label class="control-label">Package</label>
                    <ng-select id="packageType" [(ngModel)]="packingType" [ngModelOptions]="{standalone: true}" required
                               [items]="packages"
                               bindLabel="packingType"
                               [searchWhileComposing]="true"
                               placeholder="package">
                      <ng-template ng-header-tmp>
                        <div>
                          <button class="btn btn-outline-primary btn-sm" id="addNewPackage" (click)="addNewPackage()">
                            <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16"
                                 fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd"
                                    d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                              <path fill-rule="evenodd"
                                    d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                            </svg>
                            Add a new Package
                          </button>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="mb-1 control-label" for="noOfBoxes">No. Of Boxes
                    </label>
                    <input type="text" id="noOfBoxes" class="form-control" (blur)="typeNumber()"
                           [ngClass]="{'is-invalid':statusText16}" (keyup)="allowNumbersonly(noOfBoxes)"
                           [(ngModel)]="noOfBoxes" [ngModelOptions]=" {standalone: true}"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>
                    <div id="statusText16" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText16">{{statusText16}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-2 required">
                  <div class="form-group ">
                    <label class="control-label" for="length">L
                    </label>
                    <input type="text" id="length" [(ngModel)]="packingType.length"
                           [ngModelOptions]="{standalone: true}" class="form-control"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>

                  </div>
                </div>
                <div class="col-auto align-self-center">
                  <div class="form-group">*</div>
                </div>
                <div class="col col-md-2 required">
                  <div class="form-group ">
                    <label class="control-label" for="width">W
                    </label>
                    <input type="text" id="width" [(ngModel)]="packingType.width" [ngModelOptions]="{standalone: true}"
                           class="form-control"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>
                  </div>
                </div>
                <div class="col-auto align-self-center">
                  <div class="form-group">*</div>
                </div>
                <div class="col col-md-2 required">
                  <div class="form-group ">
                    <label class="control-label" for="height">H
                    </label>
                    <input type="text" id="height" [(ngModel)]="packingType.height"
                           [ngModelOptions]="{standalone: true}" class="form-control"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>

                  </div>
                </div>
                <div class="text-center" style="padding:34px"> (in cms)</div>
              </div>
              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="weight">Weight
                    </label>
                    <input type="text" id="weight" class="form-control" (keyup)="allowNumbersonly(packingType.weight)"
                           [(ngModel)]="packingType.weight" [ngModelOptions]=" {standalone: true}"
                           onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                           required>

                  </div>
                </div>
                <div class="text-center" style="padding:33px"> (in grams)</div>
                <div class="col-md-4">
                  <div class="form-group" style="padding:27px">
                    <button type="submit" (click)="addShipment()" id="add" class="btn btn-orange-prime">+Add</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="table-responsive">
            <table class="table table-stripe">
              <thead>
              <tr>
                <th [hidden]="user.role !== 'ROLE_ADMIN'">Customer Name</th>
                <th>Contact Name</th>
                <th>No. of Boxes</th>
                <th>Package Type</th>
                <th>Weight (in grams)</th>
                <th>Length (in cms)</th>
                <th>Width (in cms)</th>
                <th>Height (in cms)</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let s of shipmentDetails">
                <td *ngIf="user.role !== 'ACCOUNT_OWNER'">{{s.customerName}}</td>
                <td>{{s.contactName}}</td>
                <td>{{s.noOfBoxes}}</td>
                <td>{{s.packingType}}</td>
                <td>{{s.weight}}</td>
                <td>{{s.length}}</td>
                <td>{{s.width}}</td>
                <td>{{s.height}}</td>
                <td>
                  <a (click)="removeShip(s)">
                    <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                      <defs>
                        <style>.a {
                          fill: #848484;
                        }</style>
                      </defs>
                      <path class="a"
                            d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                            transform="translate(-7.5 -4.5)"/>
                    </svg>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/shipmentList" id="cancel" class="btn btn-cancel-prime">Cancel</button>
      <button type="submit" (click)="createShipment()" id="save" class="btn btn-orange-prime ml-2">Save</button>
    </div>
  </div>
</div>

<!--customer model-box-->
<div [ngStyle]="{'display': newCustomerPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': newCustomerPopup == 'Y'}" class="modal" id="customerDetails" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document" style="max-width:900px!important;">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Contact Details</h2>
        <button type="button" class="close" (click)="cancelNewCustomer()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="companyName">Company Name</label>
              <input type="text" id="companyName" [(ngModel)]="companyName" class="form-control"
                     (blur)="typeCompanyName()" [ngClass]="{'is-invalid':statusText1}"
                     [ngModelOptions]="{standalone: true}"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                     autocomplete="off" required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}</div>
            </div>
          </div>
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="Name">Name</label>
              <input type="text" id="name" [(ngModel)]="contactName" class="form-control" (blur)="typeName()"
                     [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                     autocomplete="off" required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">{{statusText2}}</div>
            </div>
          </div>
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="email">Email</label>
              <input type="text" id="email" [(ngModel)]="email" class="form-control" (blur)="typeEmail()"
                     [ngClass]="{'is-invalid':statusText3}" [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText3">{{statusText3}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="phone">Phone Number</label>
              <input type="text" id="phone" [(ngModel)]="mobile" class="form-control" (blur)="typePhoneNumber()"
                     [ngClass]="{'is-invalid':statusText4}"
                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"
                     [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText4">{{statusText4}}</div>
            </div>
          </div>
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="streetAddress">Address</label>
              <input type="text" id="streetAddress" [(ngModel)]="this.address.address1" class="form-control"
                     (blur)="typeAddress()" [ngClass]="{'is-invalid':statusText5}" [ngModelOptions]="{standalone: true}"
                     required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText5">{{statusText5}}</div>
            </div>
          </div>
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label">City</label>
              <ng-select type="text" id="city" [(ngModel)]="this.address.city" placeholer="City" [items]="citiesList"
                         (blur)="typeCity()" [ngClass]="{'is-invalid':statusText6}"
                         [ngModelOptions]="{standalone: true}" required>
              </ng-select>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText6">{{statusText6}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label">State</label>
              <ng-select type="text" id="State" [(ngModel)]="this.address.state" [items]="statesList" (blur)="typeState()"
                     [ngClass]="{'is-invalid':statusText7}" [ngModelOptions]="{standalone: true}" required>
              </ng-select>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText7">{{statusText7}}</div>
            </div>
          </div>
          <div class="col-md-4 required">
            <div class="form-group ">
              <label class="control-label" for="zip">Zip</label>
              <input type="text" id="zip" placeholder="Enter PinCode"
                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="6"
                     [(ngModel)]="this.address.zip" class="form-control" (change)="changeStateAndCity()"
                     (blur)="typeZipCode()" [ngClass]="{'is-invalid':statusText8}" [ngModelOptions]="{standalone: true}"
                     required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText8">{{statusText8}}</div>
            </div>
          </div>
        </div>
        <!--<div class="row">
          <div class="col-12">
            <div class="form-group ">
              <label class="control-label" for="geo">Geo Code</label>
              <input type="text" id="geo" onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="6"  [(ngModel)]="this.address.geoCode" class="form-control" [ngModelOptions]="{standalone: true}" required>
          </div>
          </div>
        </div>-->
      </div>
      <div class="modal-footer border-0">
        <button type="reset" class="btn btn-cancel" id="clear" (click)="clearCustomerFields()">Clear</button>
        <button type="submit" (click)="submitContacts()" id="saveDetails" class="btn btn-orange ml-2">Save</button>
      </div>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': newPackagePopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': newPackagePopup == 'Y'}" class="modal" id="packageDetails" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Package Configuration</h2>
        <button type="button" class="close" (click)="cancelNewPackage()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group required">
              <label class="control-label" for="packageType">Package Type</label>
              <input type="text" id="packageType" [(ngModel)]="this.packageType" class="form-control"
                     (blur)="typePackageType()" [ngClass]="{'is-invalid':statusText9}"
                     [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login " [hidden]="!statusText9">{{statusText9}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group required">
              <div class="input-group">
                <input type="text" [(ngModel)]="this.boxLength" class="form-control" style="border-radius: 4px;"
                       (blur)="typeLength()" [ngClass]="{'is-invalid':statusText10}"
                       [ngModelOptions]="{standalone: true}"
                       onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                       placeholder="L"/>
                <span class="input-group-addon ml-2 mr-3">*</span>
                <input type="text" [(ngModel)]="this.boxWidth" [ngModelOptions]="{standalone: true}"
                       class="form-control" style="border-radius: 4px;" (blur)="typeWidth()"
                       [ngClass]="{'is-invalid':statusText11}"
                       onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                       placeholder="W"/>
                <span class="input-group-addon ml-2 mr-3">*</span>
                <input type="text" [(ngModel)]="this.boxHeight" [ngModelOptions]="{standalone: true}"
                       class="form-control" style="border-radius: 4px;" (blur)="typeHeight()"
                       [ngClass]="{'is-invalid':statusText12}"
                       onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                       placeholder="H"/>
              </div>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText10">{{statusText10}}</div>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText11">{{statusText11}}</div>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText12">{{statusText12}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group required">
              <label class="control-label" for="this.pweight">Weight</label>
              <input type="text" id="this.pweight" [(ngModel)]="this.pweight" class="form-control" (blur)="typeWeight()"
                     [ngClass]="{'is-invalid':statusText13}" [ngModelOptions]="{standalone: true}"
                     onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'
                     required>
              <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText13">{{statusText13}}</div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col text-right">
            <button type="submit" id="cancelPackage" class="btn btn-cancel">Cancel</button>
            <button type="submit" class="btn btn-orange ml-2" id="savePackage" (click)="submitPackage()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
